export default __webpack_public_path__ + "static/TinyCam-Monitor_16-382ae3e76c3af9e054b7d61d47efe863.webp";